// Scenario data for 2026 World Cup ROI calculations (48-team format)
export const scenarioData = {
  group_stage: {
    id: 'group_stage',
    label: 'Group Stage Exit',
    probability: '10%',
    brandValueIncrease: -40,
    sponsorshipIncrease: -15,
    mediaRightsIncrease: 5,
    ticketRevenue: 45,
    merchandiseIncrease: 10,
    insight: 'A group stage exit as co-host represents significant brand value destruction. While host premium provides baseline revenue floor, failure to advance would materially impact 2027+ sponsorship renewal negotiations.',
    riskLevel: 'high',
  },
  round_of_32: {
    id: 'round_of_32',
    label: 'Round of 32',
    probability: '15%',
    brandValueIncrease: 10,
    sponsorshipIncrease: 5,
    mediaRightsIncrease: 8,
    ticketRevenue: 55,
    merchandiseIncrease: 15,
    insight: 'Round of 32 advancement represents minimum knockout-stage participation in the expanded 48-team format. As co-host, this outcome delivers modest uplift but below market expectations for quarterfinal base case.',
    riskLevel: 'medium',
  },
  round_of_16: {
    id: 'round_of_16',
    label: 'Round of 16',
    probability: '30%',
    brandValueIncrease: 25,
    sponsorshipIncrease: 15,
    mediaRightsIncrease: 12,
    ticketRevenue: 65,
    merchandiseIncrease: 22,
    insight: 'Round of 16 advancement meets baseline expectations for co-host advancement. Host premium captures baseline value with moderate differentiation from 2022 performance.',
    riskLevel: 'medium',
  },
  quarterfinal: {
    id: 'quarterfinal',
    label: 'Quarterfinal',
    probability: '25%',
    brandValueIncrease: 50,
    sponsorshipIncrease: 35,
    mediaRightsIncrease: 25,
    ticketRevenue: 85,
    merchandiseIncrease: 40,
    insight: 'Quarterfinal advancement represents the base case projection. This outcome meets market expectations and positions favorably for 2027-2030 commercial cycle negotiations.',
    riskLevel: 'low',
  },
  semifinal: {
    id: 'semifinal',
    label: 'Semifinal',
    probability: '14%',
    brandValueIncrease: 125,
    sponsorshipIncrease: 65,
    mediaRightsIncrease: 45,
    ticketRevenue: 110,
    merchandiseIncrease: 75,
    insight: 'Semifinal achievement would represent historic success. Estimated net value creation of +$129M materially strengthens long-term sponsorship leverage ahead of commercial cycle peak.',
    riskLevel: 'low',
  },
  champion: {
    id: 'champion',
    label: 'World Cup Champion',
    probability: '6%',
    brandValueIncrease: 250,
    sponsorshipIncrease: 120,
    mediaRightsIncrease: 85,
    ticketRevenue: 140,
    merchandiseIncrease: 150,
    insight: 'Championship outcome represents transformational brand event. Would establish USMNT as global Tier-1 property, fundamentally reshaping commercial valuation benchmarks for North American soccer.',
    riskLevel: 'low',
  },
};

// Fixed costs for tournament participation
export const tournamentCosts = {
  squadPreparation: 12,
  coachingStaff: 8,
  logistics: 15,
  camps: 5,
  total: 40,
};

// Sensitivity variables
export const sensitivityFactors = {
  keyPlayerInjury: {
    label: 'Key Player Injury',
    description: 'Pulisic or Adams unavailable for knockout rounds',
    impact: -25,
    probability: '20%',
  },
  earlyElimination: {
    label: 'Early Elimination',
    description: 'Group stage exit scenario',
    impact: -65,
    probability: '15%',
  },
  hostPremium: {
    label: 'Host Premium Leverage',
    description: 'Additional home advantage monetization',
    impact: 35,
    probability: '85%',
  },
};

export const scenarioOptions = Object.values(scenarioData).map(s => ({
  value: s.id,
  label: s.label,
  probability: s.probability,
}));
